export default "__VITE_ASSET__D$o7Mpsc__"